import { render, staticRenderFns } from "./ArtistDetails.vue?vue&type=template&id=0b15332e&scoped=true"
import script from "./ArtistDetails.vue?vue&type=script&lang=js"
export * from "./ArtistDetails.vue?vue&type=script&lang=js"
import style0 from "./ArtistDetails.vue?vue&type=style&index=0&id=0b15332e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15332e",
  null
  
)

export default component.exports